import { Formik } from "formik";
import { FormControl, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

import SubmitButton from "components/Button/SubmitButton";
import { getFormattedDate, subtractFromDate } from "utils/date";
import { billingReportSchema } from "schemas/billingReportSchema";
import useBillingReportForm from "../hooks/useBillingReportForm";
import Loading from "components/common/loading/Loading";

const BillingReportForm = ({ onClose }) => {
  const { downloadBillingReportData, isDownloading } = useBillingReportForm({
    onClose,
  });

  const handleFormSubmit = async (values) => {
    await downloadBillingReportData(values);
  };

  return (
    <Formik
      initialValues={{
        startDate: getFormattedDate(subtractFromDate(new Date(), 1).toDate()),
        endDate: getFormattedDate(new Date()),
      }}
      validationSchema={billingReportSchema}
      onSubmit={handleFormSubmit}
      enableReinitialize
    >
      {({ values, setFieldValue, handleSubmit, errors, touched }) => {
        return (
          <>
            {isDownloading ? (
              <Loading />
            ) : (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                    marginBottom: "20px",
                    marginTop: "20px",
                  }}
                >
                  <FormControl
                    fullWidth
                    error={touched.startDate && Boolean(errors.startDate)}
                  >
                    <DatePicker
                      margin="none"
                      id="billing_report_start_date"
                      label="Start Date"
                      className="view-pdf__input"
                      name="startDate"
                      value={values.startDate ? dayjs(values.startDate) : null}
                      onChange={(date) => {
                        const value = date ? getFormattedDate(date) : null;
                        setFieldValue("startDate", value);
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          required: true,
                          error: touched.startDate && Boolean(errors.startDate),
                          helperText: touched.startDate && errors.startDate,
                          readOnly: true,
                        },
                      }}
                      maxDate={
                        values.endDate
                          ? dayjs(values.endDate)
                          : dayjs(new Date())
                      }
                      minDate={dayjs(new Date()).subtract(6, "month")}
                    />
                  </FormControl>
                  <FormControl fullWidth>
                    <DatePicker
                      margin="none"
                      id="billing_report_end_date"
                      label="End Date"
                      className="view-pdf__input"
                      value={values.endDate ? dayjs(values.endDate) : null}
                      onChange={(date) => {
                        const value = date ? getFormattedDate(date) : null;
                        setFieldValue("endDate", value);
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          required: true,
                          error: touched.endDate && Boolean(errors.endDate),
                          helperText: touched.endDate && errors.endDate,
                          readOnly: true,
                        },
                      }}
                      maxDate={dayjs(new Date())}
                      minDate={dayjs(new Date()).subtract(6, "month")}
                    />
                  </FormControl>
                </div>
              </div>
            )}

            <div className="view-pdf__button-container">
              <Button
                onClick={onClose}
                className="view-pdf__button"
                variant="outlined"
                color="secondary"
                disabled={isDownloading}
              >
                Cancel
              </Button>
              <SubmitButton
                buttonText="Download"
                className="view-pdf__button"
                handleClick={handleSubmit}
                disabled={isDownloading}
              />
            </div>
          </>
        );
      }}
    </Formik>
  );
};

export default BillingReportForm;
